"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OAuthGrantType = void 0;
/**
 * Refer to our documentation at https://docs.manifold.xyz/v/manifold-for-developers/resources/apps/grant-types#signature-grant to learn more about Grant Type
 */
var OAuthGrantType;
(function (OAuthGrantType) {
    OAuthGrantType["TOKEN"] = "token";
    OAuthGrantType["SIGNATURE"] = "signature";
})(OAuthGrantType = exports.OAuthGrantType || (exports.OAuthGrantType = {}));
